import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A-frame fish drying rack with hanging fish silhouettes.
const build: (ctx: DecoBuildCtx) => void = ({ box, bone, seed }) => {
  const wood = shade(0x6b5334, (rand(seed) - 0.5) * 0.1);
  const fish = shade(0x7a8a6a, (rand(seed + 1) - 0.5) * 0.12);
  // A-frame
  box(-0.55, 0.7, 0, 0.1, 1.5, 0.1, wood);
  box(0.55, 0.7, 0, 0.1, 1.5, 0.1, wood);
  box(0, 1.4, 0, 1.3, 0.1, 0.1, wood);
  box(0, 0.9, 0, 1.1, 0.08, 0.08, wood);
  // Fish hanging from crossbar
  for (let i = 0; i < 4; i++) {
    const x = -0.45 + i * 0.3;
    const fy = 0.55 + (i % 2) * 0.12;
    box(x, 1.2, 0, 0.02, 0.25, 0.02, shade(wood, 0.15));
    bone(x, fy, 0, x, fy + 0.45, 0, 0.08, 0.04, fish, 0.55);
    box(x, fy + 0.48, 0.02, 0.04, 0.04, 0.12, shade(fish, -0.15)); // tail stub
  }
};

export default build;
